import { Pipe, PipeTransform } from '@angular/core';
import { UK_Zones } from 'src/app/core/constants/ZonesIds';

@Pipe({
  name: 'DistanceUnitByZoneId'
})
export class DistanceUnitByZoneId implements PipeTransform {
  transform(zoneId: string | undefined): string {

    if (zoneId) {
      if (UK_Zones.includes(zoneId)) {
        return "mi";
      }
    }

    return "km";
  }
}